import React, { useMemo } from "react";
import { ReactifyChartColors } from "Util/ReactifyChartColors";

const colors = ReactifyChartColors();

import Chart from "react-apexcharts";

function DonutChart() {
  const { options, series } = useMemo(
    () => ({
      options: {
        colors: [
          colors.ReactifyChartColor1,
          colors.ReactifyChartColor2,
          colors.ReactifyChartColor3,
          colors.ReactifyChartColor4
        ],
        labels: ["USA", "CA", "UK", "FRA"],
        legend: {
          show: false
        }
      },
      series: [44, 55, 13, 43]
    }),
    []
  );

  return (
    <Chart
      options={options}
      series={series}
      type="donut"
      width="100%"
      height="280px"
    />
  );
}

export default DonutChart;
